import styled from '@emotion/styled';
import { Switch } from '@mui/material';

const LargeSwitch = styled(Switch)`
  width: 78px;
  height: 48px;
  padding: 13px;

  .MuiSwitch-switchBase {
    &.Mui-checked {
      transform: translateX(25.5px);
    }
  }

  .MuiSwitch-thumb {
    width: 30px;
    height: 30px;
  }

  .MuiSwitch-track {
    border-radius: 15px;
    background-color: #9d9d9d;
    opacity: 1;
  }
`;

export default LargeSwitch;
